module.exports = __webpack_public_path__ + "img/pchomeadon.7563b1e8.svg";